import { ChainId, NETWORK_CONFIG } from '@/constant';
import { Lazbubu } from '@/gql/graph/__generated__/request';
import application from '@/stores/application';
import serverConfig from '@/stores/serverConfig';
import user from '@/stores/user';
import { formatHashValue } from '@/utils';
import { Box, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';

export const LazbubuIncubator: React.FC<{ lazbubu?: Lazbubu }> = observer(
    ({ lazbubu }) => {
        const handleClick = () => {
            if (lazbubu) {
                application.toggleLazbubuDrawer();
            } else {
                application.toggleIncubatorDrawer();
            }
        };

        const onClickDat = () => {
            const explorer =
                NETWORK_CONFIG[user.chainId || ChainId.testnet].explore;
            if (lazbubu) {
                window.open(
                    `${explorer}/token/${serverConfig?.config?.contracts.dataAnchoringTokenAddress}/instance/${lazbubu.tokenId}`,
                    '_blank',
                );
            } else {
                window.open(
                    `${explorer}address/${serverConfig?.config?.contracts.dataAnchoringTokenAddress}`,
                    '_blank',
                );
            }
        };

        return (
            <Box
                className="flex flex-col items-center justify-center cursor-pointer transition-transform hover:scale-105"
                onClick={handleClick}
            >
                <img
                    className="w-[120px] h-[120px] rounded-full shadow-lg hover:shadow-xl transition-shadow"
                    src={
                        lazbubu
                            ? lazbubu.image
                            : require('@/assets/images/lazbubu-incubator.png')
                    }
                    alt="Lazbubu Incubator"
                />
                <Typography className="mt-4 font-bold text-[20px] hover:text-blue-600 transition-colors">
                    {lazbubu ? lazbubu.name : 'Lazbubu Incubator'}
                </Typography>
                <div className="flex flex-row items-center justify-center gap-2 bg-[#EBEFFE] rounded-[10px] p-4 mt-4">
                    <Typography className="text-[14px] ">
                        {lazbubu ? 'Token ID:' : 'Onchain DAT:'}
                    </Typography>
                    <div
                        className="text-[14px] text-[#3563F3] underline"
                        onClick={onClickDat}
                    >
                        {lazbubu
                            ? lazbubu.tokenId
                            : formatHashValue(
                                  serverConfig.config?.contracts
                                      .dataAnchoringTokenAddress,
                              )}
                    </div>
                </div>
            </Box>
        );
    },
);
// UI Components for pages
export { HowToGetBoxModal } from './HowToGetBoxModal';
export { WhitelistInfoPrompt } from './WhitelistInfoPrompt';
